export const EMAIL_TAGS = [
    { value: 'contactFirstName', title: "Organisation's contact first name" },
    { value: 'organisationName', title: "Organisation's name" },
    { value: 'basMonth', title: 'Bas Month (e.g. December)' },
    { value: 'basYearMonth', title: 'Bas Month & Year (e.g. December 2023)' },
    { value: 'clientManagerFirstName', title: "Manager's first name" },
    { value: 'clientManagerLastName', title: "Manager's last name" },
    { value: 'numberUnreconciledBankTransactions', title: 'Number of unreconciled bank transactions' },
];
